export default __webpack_public_path__ + "images/G9.4f2b397.png";